export default "__VITE_ASSET__7ba7a242__"